import styled from '@emotion/styled'
import { Stack } from '@mui/system'

export const StickyStack = styled(Stack)`
	position: -webkit-sticky;
	position: sticky;
	align-self: flex-start;
	top: ${({ theme }) => theme.spaces.m};
	overflow-y: auto;
`

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex: 1;
	min-width: 360px;
	${({ theme }) => `
		background-color: ${theme.palette.backgroundColors.lighterGrey};
	`}
	border-radius: 4px;
	padding: 1.5rem;
	height: 100%;
`
